<template>
    <div class="gofixInput gofixDateInput" v-bind:class="{gofixInputHasDesc:desc,gofixInputError : (required && !value && blurInput),gofixInputDisable:disabled,gofixInputNoLabel:!label}">
        <div class="mainInput">
            <v-date-picker
                    v-bind:class="{gofixDateInputOpen:openPopover,gofixDateInputHasValue:value}"
                    :formats="{input: ['DD.MM.YYYY']}"
                    :attributes="[{
                      key: 'today',
                      contentStyle: {
                          color: '#F22B1E'
                      },
                      dates: new Date(),
                    }]"
                    :value="value"
                    :input-props='{ class: "form-control inputDate",placeholder:"",autocomplete:"off"}'
                    :mode="mode"
                    :placeholder="placeholder"
                    :max-date="maxDate"
                    :min-date="minDate"
                    :popover-visibility="popoverVisibility"
                    :popover-direction="popoverDirection"
                    :popover-align="popoverAlign"
                    @input="handleInput"
                    @popover-will-appear="openDatePopover"
                    @popover-will-disappear="hideDatePopover"
            >
            </v-date-picker>
            <div class="label">{{label}}<span class="iconRequired" v-if="showIconRequired && required">*</span></div>
        </div>
        <p class="desc" v-if="desc" v-html="desc"></p>
    </div>
</template>

<script>
    import { setupCalendar, DatePicker } from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';

    setupCalendar({
        firstDayOfWeek: 2 // Monday
    });
    export default {
        name: "date-input",
        components: {
            'v-date-picker': DatePicker
        },
        props: {
            desc: {
                type: String,
                required: false,
                default: () => "dd.mm.yyyy"
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            label: {
                type: String,
                required: false,
                default: () => "Label"
            },
            value: {
                default: () => null
            },

            disabled: {
                type: Boolean,
                default: false
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            mode: {
                type: String,
                required: false,
                default: () => "single"
            },
            placeholder: {
                type: String,
                required: false,
                default: () => null
            },
            maxDate: {
                required: false,
                default: () => null
            },
            minDate: {
                required: false,
                default: () => null
            },
            popoverDirection: {
                type: String,
                required: false,
                default: () => "bottom"
            },
            popoverVisibility: {
                type: String,
                required: false,
                default: () => "focus"
            },
            popoverAlign: {
                type: String,
                required: false,
                default: () => "left"
            },
        },

        data() {
            return {
                blurInput:false,
                openPopover:false,
            }
        },
        watch: {


        },
        created(){

        },
        methods: {
            handleInput (e) {
                this.$emit("input", e);
                this.$emit("change", e);
            },
            openDatePopover(){
                this.openPopover = true;
            },
            hideDatePopover(){
                this.openPopover = false;
                this.blurInput = true;
            }
        }
    }
</script>

<style scoped>

</style>
